const urlPrefix = '/hubspot'

export const LoadHubspotSingle =
  ({ RestService, HubspotService, pResponseHubspotSingle, endpoint }) =>
  async (hungryId) => {
    const urlString = `${urlPrefix}/${endpoint}/${hungryId}`
    try {
      const response = await RestService.get(urlString)
      HubspotService.setSingle(pResponseHubspotSingle(response))
    } catch (e) {
      HubspotService.setSingle(null)
    }
  }

export const LoadOrSearchHubspotList =
  ({
    RestService,
    HubspotService,
    pRequestHubspotList,
    pResponseHubspotList,
    endpoint,
  }) =>
  async ({ search, page, results_per_page }) => {
    const params = pRequestHubspotList({
      searchString: search,
      page,
      limit: results_per_page,
    })
    const urlString = `${urlPrefix}/${endpoint}`
    const response = await RestService.get(urlString, params)

    HubspotService.setList(pResponseHubspotList(response))

    return pResponseHubspotList(response)
  }

export const SearchHubspotCompanyById =
  ({
    RestService,
    HubspotService,
    pResponseHubspotList,
    endpoint,
    HandleError,
  }) =>
  async ({ search: id }) => {
    HubspotService.setList([])
    try {
      if (!id) {
        return []
      }
      const urlString = `${urlPrefix}/${endpoint}/${id}/full`
      const company = await RestService.get(urlString)
      const fullCompanyList = pResponseHubspotList([company])
      HubspotService.setList(fullCompanyList)

      return fullCompanyList
    } catch (error) {
      HandleError({ error })

      return []
    }
  }

export const GetHubspotCompanyById =
  ({ RestService, pResponseFullHubspotCompany, endpoint, HandleError }) =>
  async (id, params = {}) => {
    try {
      if (!id) {
        return null
      }

      const urlString = `${urlPrefix}/${endpoint}/${id}/full`
      const response = await RestService.get(urlString, params)

      return pResponseFullHubspotCompany(response)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

export const SetHubspotRelation =
  ({
    RestService,
    HubspotService,
    pResponseHubspotSingle,
    endpoint,
    HandleError,
  }) =>
  async (hungryId, hubspotId, name) => {
    try {
      const urlString = `${urlPrefix}/${endpoint}`
      const params = { hubspotId: hubspotId, hungryId: hungryId, name }
      const response = await RestService.post(urlString, params)

      HubspotService.setSingle(pResponseHubspotSingle(response))
    } catch (error) {
      HandleError({ error })
    }
  }

export const UpdateHubspotCompanies =
  ({ RestService, HubspotService, pResponseHubspotList, endpoint }) =>
  async (companies) => {
    try {
      companies.forEach((c) => {
        c.id = c.id.toString()
      })
      const response = await RestService.put(`${urlPrefix}/${endpoint}`, {
        inputs: companies,
      })
      HubspotService.setCompaniesInCompanies(pResponseHubspotList(response))

      return true
    } catch (e) {
      return false
    }
  }

export const ChangeHubspotCompany =
  ({ RestService, HandleError }) =>
  async ({ hungryId, hubspotId }) => {
    try {
      const response = await RestService.post(
        `${urlPrefix}/companies/${hungryId}/change-hubspot-company`,
        {
          hubspotId,
        },
      )

      return response
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

export const CheckSchemaDrift =
  ({ RestService, HandleError }) =>
  async (objectType) => {
    try {
      const drift = await RestService.post('/hubspot/schemas/check-drift', {
        objectType,
      })

      return drift
    } catch (error) {
      HandleError({ error })

      return null
    }
  }
